import { render, staticRenderFns } from "./PauliExclusionViz.vue?vue&type=template&id=826a9b20&scoped=true"
import script from "./PauliExclusionViz.vue?vue&type=script&lang=js"
export * from "./PauliExclusionViz.vue?vue&type=script&lang=js"
import style0 from "./PauliExclusionViz.vue?vue&type=style&index=0&id=826a9b20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826a9b20",
  null
  
)

export default component.exports